import React, { useEffect } from 'react';
import styled from 'styled-components';
import Designer from './Designer';
import Toolbar from './Toolbar';
import LeftPanel from './LeftPanel/LeftPanel';
import { useDesignContext } from '../hooks/useDesignContext';

const AppContainer = styled.div`
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: #f0f0f0;
  overflow: hidden;
`;

const MainContent = styled.div`
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
  display: grid;
  grid-template-columns: 100px 1fr;
  flex: 1;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  position: relative;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column-reverse;
    height: 100%;
  }
`;

const DesignerContainer = styled.div`
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-width: 0;
  overflow: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x pan-y;

  @media (max-width: 768px) {
    flex: 1;
    height: auto;
    min-height: 0;
  }
`;

const LeftPanelWrapper = styled.div<{ $hideOnMobile: boolean }>`
  height: 100%;
  width: 100%;

  @media (max-width: 768px) {
    display: ${props => props.$hideOnMobile ? 'none' : 'block'};
    width: 100%;
    height: auto;
  }
`;

interface DesignerWorkspaceProps {
  mode?: 'LSP/QD' | 'ESQ';
}

const DesignerWorkspace: React.FC<DesignerWorkspaceProps> = ({ mode }) => {
  const { selectedElement, designMode, setDesignMode } = useDesignContext();

  useEffect(() => {
    if (mode) {
      try {
        sessionStorage.setItem('design_tool.page_mode', mode);
        localStorage.setItem('design_tool.mode', mode);
      } catch { }
      if (designMode !== mode) {
        setDesignMode(mode);
      }
    }
  }, [mode, designMode, setDesignMode]);

  return (
    <AppContainer>
      <Toolbar />
      <MainContent>
        <LeftPanelWrapper $hideOnMobile={!!selectedElement}>
          <LeftPanel />
        </LeftPanelWrapper>
        <DesignerContainer>
          <Designer />
        </DesignerContainer>
      </MainContent>
    </AppContainer>
  );
};

export default DesignerWorkspace;
